var React = require('react');
var Modal = require('react-modal');
var FontAwesome = require('react-fontawesome');
var styles = require('./CheckBox.scss');

var CheckBox = React.createClass({
    propTypes: {
        id: React.PropTypes.string.isRequired,
        value: React.PropTypes.bool,
        label: React.PropTypes.string,
        onChange: React.PropTypes.func,
        enabled: React.PropTypes.bool,
        modalHeader: React.PropTypes.string,
        modalBody: React.PropTypes.object,
        infoBody: React.PropTypes.string
    },
    getDefaultProps: function() {
        return {
            id: null,
            value: false,
            onChange: null,
            enabled: false,
            visible: true,
            label: '[label]'
        };
    },
    getInitialState: function() {
        return {
            checked: this.props.value,
            modalIsOpen: false
        }
    },
    componentWillReceiveProps: function(nextProps) {
        this.setState({
            checked: nextProps.value
        });
    },
    openModal: function() {
        this.setState({modalIsOpen: true});
    },
    closeModal: function() {
        this.setState({modalIsOpen: false});
    },
    render: function() {
        if (!this.props.visible) {
            return null;
        }
        var classes = ['checkbox', 'input'];
        if (!this.props.enabled) {
            classes.push('disabled-view');
        }
        var modalClass = null;
        if (!this.props.modalBody) {
            modalClass = 'hidden';
        }
        var infoBody = null;
        if (this.props.infoBody) {
            infoBody = (<div>{this.props.infoBody}</div>);
        }
        return (
            <label className={classes.join(' ')}>
                <input
                    onChange={this.handleChange}
                    checked={this.state.checked}
                    type="checkbox"
                    disabled={!this.props.enabled}
                    id={this.props.id}
                    value={this.state.checked}
                 />
                <i></i>
                {this.props.label}
                <a href="#" onClick={this.openModal} className={modalClass}>
                    <FontAwesome name='info-circle' className={styles.info} />
                </a>
                {infoBody}
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closeModal}
                    className={styles.modal}
                    contentLabel={styles.header}
                    overlayClassName={styles.overlay}>

                        <div className={styles.header}>
                            <p>{this.props.modalHeader}</p>
                        </div>
                        <div className={styles.body}>{this.props.modalBody}</div>
                        <div className={styles.close}>
                            <button onClick={this.closeModal}>Close</button>
                        </div>

                </Modal>
            </label>
        )
    },
    handleChange: function(e) {
        if (this.props.onChange) {
            var change = {
                oldValue: this.state.checked,
                newValue: e.target.checked
            };
            this.props.onChange(change);
        }
        this.setState({checked: e.target.checked});
    }
});

module.exports = CheckBox;


// WEBPACK FOOTER //
// ./app/components/CheckBox.js